import React from 'react';
import styled, { css } from 'styled-components';
import useScrollIsShow from '@/hooks/useScrollIsShow';

import Header from '@/ui/Header';

import {
  GNB_HEIGHT,
  HEADER_HEIGHT,
  LAYOUT_MAX_WIDTH,
  LAYOUT_OVER_WIDTH,
} from '@/styles';
import Footer from '@/ui/Footer';
import { BottomSheetNameType } from '@/types';

export interface AppLayoutPropsType {
  content: React.ReactNode | React.ReactNode[];

  isHeaderExist?: boolean;
  isFooterExist?: boolean;
  isQuickExist?: boolean;
  quickSize?: 'm' | 'l' | 'full';

  isGnbExist?: boolean;
  isGnbArea?: boolean;
  layoutType?: 'full' | 'default' | 'responsive';
  infoState?: boolean;
  bottomSheet?: React.ReactNode | React.ReactNode[];
  bottomSheetName?: BottomSheetNameType;
  floatingArea?: React.ReactNode;
}

const AppLayout = ({
  content,
  isHeaderExist = true,
  isFooterExist = true,
  isQuickExist = true,
  isGnbExist = true,
  layoutType = 'default',
  quickSize = 'm',
  bottomSheet,
  infoState,
  bottomSheetName,
  isGnbArea = true,
  floatingArea,
}: AppLayoutPropsType) => {
  const { ref: headerRef } = useScrollIsShow(0.1);
  return (
    <Layout>
      {/* header 영역 */}
      {isHeaderExist && <Header ref={headerRef} isGnbExist={isGnbExist} />}

      {/* content 영역 */}
      <ContentBox type={layoutType}>
        <ContentWrap isGnbArea={isGnbArea} isGnbExist={isGnbExist}>
          {content}
        </ContentWrap>
      </ContentBox>

      {/* footer 영역 */}
      {isFooterExist && <Footer />}

      {/* floating 영역 */}
      {floatingArea}
    </Layout>
  );
};

export default AppLayout;

const Layout = styled.div`
  position: relative;
  width: 100%;
  margin-top: -${HEADER_HEIGHT}px;
`;

const ContentWrap = styled.div<{ isGnbExist: boolean; isGnbArea: boolean }>`
  ${({ isGnbArea, isGnbExist }) => {
    if (isGnbArea) {
      return css`
        padding-top: ${isGnbExist ? HEADER_HEIGHT + 60 : HEADER_HEIGHT}px;
      `;
    } else {
      return css`
        padding-top: ${HEADER_HEIGHT}px;
      `;
    }
  }}
`;

const ContentBox = styled.section<{ type: 'full' | 'default' | 'responsive' }>`
  min-height: calc(100vh - ${HEADER_HEIGHT + GNB_HEIGHT}px);
  margin: 0 auto;
  ${({ type }) => {
    if (type === 'full') {
      return `
        width: 100%;
      `;
    } else if (type === 'default') {
      return `
        width: ${LAYOUT_MAX_WIDTH}px;
      `;
    } else if (type === 'responsive') {
      return `
        width: 100%;
        max-width: ${LAYOUT_OVER_WIDTH}px;
      `;
    }
  }}
`;
